import React from "react";
import bg from "../assets/img/login-page-bg.png";
import logo from "../assets/img/youl-systems-logo.svg";
import LoginForm from "../components/login/LoginForm";

export default function Login() {
  return (
    <main className="bg-[#9E9E9E] relative ">
      {/* bg  */}
      <img
        src={bg}
        alt=""
        className="absolute top-0 left-0 w-full h-full object-cover"
      />
      {/* content  */}
      <section className="h-screen xl:py-[125px] py-16 px-5 sm:px-7 relative z-[2] flex flex-col gap-16 2xl:gap-[181px] overflow-y-auto">
        <div className="flex flex-col gap-8 xl:gap-[59px] ">
          {/* logo  */}
          <img
            src={logo}
            alt=""
            className="w-[200px] sm:w-[300px] xl:text-[444px] max-w-full mx-auto"
          />

          <p className="text-center text-white text-[18px] sm:text-[24px] xl:text-[33px] xl:tracking-[6.6px] sm:tracking-[3px] tracking-[2px] font-normal bebas-neue-font">
            TURNING IMAGINATION INTO REALITY, AND REALITY INTO THE FUTURE
          </p>
        </div>

        <LoginForm />
      </section>
    </main>
  );
}
